module.exports = __webpack_public_path__ + "static/media/corpBanner.158f1f93.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/corpBanner.jpg
// module id = 366
// module chunks = 0